export const API_URL = `${process.env.REACT_APP_API_URL}/api`;
export const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY || 'KEY_NOT_SET';

export const DEFAULT_CURRENCY = 'AMD';

// Date configs -- START
export const DATE_FORMATS = ['dd/MM/yyyy', 'dd.MM.yyyy', 'dd-MM-yyyy', 'ddMMyyyy'];
// Date configs -- END

export const INCOMPLETE_DOCS_ACTION_ID = process.env.REACT_APP_INCOMPLETE_DOCS_ACTION_ID;
export const CONSULTING_TIME_ACTION_ID = process.env.REACT_APP_CONSULTING_TIME_ACTION_ID;

export const EXAMINATION_ACTION_ID = process.env.REACT_APP_EXAMINATION_ACTION_ID;
export const HIDE_CMTPL_CALC = process.env.REACT_APP_HIDE_CMTPL_CALC === 'true';
